export const FirebaseConfig = {
	"projectId": "dropin-rides",
	"appId": "1:517328404256:web:040d59dd52949c97502145",
	"databaseURL": "https://dropin-rides-default-rtdb.firebaseio.com",
	"storageBucket": "dropin-rides.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyDKw_cQLQr4UqVNBMO8AG4DUfmMmWhzpFQ",
	"authDomain": "dropin-rides.firebaseapp.com",
	"messagingSenderId": "517328404256",
	"measurementId": "G-M39S2RGHCX"
};